import PropTypes from 'prop-types';
import React from 'react';
import { QuizResultsCapabilityProvider } from '@sm/question-widgets/respondent-quiz-results';
import SurveyPage from '~app/components/Survey/SurveyPage';
import './survey-pages.scss';

const SurveyPages = props => {
  const { pages, survey } = props;
  const totalPages = pages.length;
  const pagesElement = pages.map((page, idx) => {
    if (survey[page.id]) {
      return <SurveyPage page={page} survey={survey} pageIndex={idx} totalPages={totalPages} key={`page_${page.id}`} />;
    }
    return null;
  });
  const settings = {
    survey: {
      numberingEnabled: survey.enableNumbering,
    },
  };
  return (
    <QuizResultsCapabilityProvider settings={settings}>
      <div className="sm-survey-pages--container" data-testid="SurveyPages__Container">
        <div>{pagesElement}</div>
      </div>
    </QuizResultsCapabilityProvider>
  );
};

SurveyPages.propTypes = {
  pages: PropTypes.arrayOf(PropTypes.shape({})),
  survey: PropTypes.shape({
    enableNumbering: PropTypes.bool.isRequired,
  }),
};

SurveyPages.defaultProps = {
  pages: [],
  survey: null,
};

export default SurveyPages;
